import api from "@/api";

export default {
    namespaced: true,

    state: {
        pdfStatus: {
            status: null
        },
        loadingPdfModal: false
    },

    mutations: {
        setPdfStatus(state, status) {
            state.pdfStatus = status
        },

        togglePdfModal(state, value) {
            state.loadingPdfModal = value
        }
    },

    actions: {
        async generatePdfLink(context, {list, pdfConfig}) {
            let language = context.rootState.currentLanguage
            const url = '/admin/generatePdf'
            const body = {
                question_uids: list,
                page_width: pdfConfig.page_width,
                page_height: pdfConfig.page_height,
                sticker_width: pdfConfig.sticker_width,
                col_count: pdfConfig.col_count,
                sticker_type: pdfConfig.sticker_type,
                show_border: pdfConfig.show_border,
                language: language
            }
            try {
                const response = await api.request("post", url, body);
                return response.data.uid
            } catch (error) {
                throw error;
            }
        },
        async generatePdfByRange(context, {pdfConfig}) {
            let language = context.rootState.currentLanguage
            const url = '/admin/generatePdfByRange'
            let body = pdfConfig
            body.language = language
            try {
                const response = await api.request("post", url, body);
                return response.data.uid
            } catch (error) {
                throw error;
            }
        },

        async chekPdfStatus(context, pdfId) {
            const url = `/admin/pdf/${pdfId}/status`
            try {
                const response = await api.request("get", url);
                context.commit('setPdfStatus', response.data)
                return response.data
            } catch (error) {
                throw error;
            }
        }
    }
}